var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"color":_vm.color,"elevation":"13","type":_vm.type}},[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }